import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
export class AbstractAdapter extends AbstractTagClass {
    #player;
    constructor(argument) {
        super(argument);
    }
    get player() {
        return this.#player;
    }
    set player(value) {
        this.#player = value;
    }
    importDependencies = (imports) => {
        return new Promise((resolve, reject) => {
            this.utils.Importer.import(imports, true).then((data) => {
                resolve({ msg: 'Done!', success: true, imports: data.imports });
            }).catch((data) => {
                reject({ msg: 'Dependencies import error!', success: false, imports: data.imports });
            });
        });
    };
}
